import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
// import { SiLeetcode } from "react-icons/si";
import {
  AboutDiv,
  Column,
  Img,
  AboutInfo,
  AboutInfoP,
  HeaderUl,
  HeaderLi,
  JelloHori,
  Column1,
} from "./Styles";

import { Container, H1 } from "../../SharedStyles/SharedStyles";
const socialMediaLinks = [
  {
    id: 0,
    link: "https://www.linkedin.com/in/dhananjay-kumar-verma",
    icon: <FaLinkedin />,
  },
  {
    id: 1,
    link: "https://github.com/dhananjayverma",
    icon: <FaGithub />,
  },
];
const About = () => {
  return (
    <Container className="about">
      <br />
      <AboutDiv>
       <Column1>
         

       
        
         <Img src="https://user-images.githubusercontent.com/108890988/210940423-dbbc60b2-6384-456b-bd10-7c98a0ce0b45.jpg" alt="my-img"/>
        </Column1>
        <Column>
          <H1>About Me</H1>
          <AboutInfo>
            <AboutInfoP>
             A dedicated and experienced Full Stack Developer with expertise in React, 
             Angular, Node.js. Proficient in performance optimization and pixel-perfect design. 
             Skilled in React Native for cross-platform app development and TypeScript for enhanced scalability.
              Committed to delivering seamless user experiences across platforms, leveraging comprehensive
               knowledge of both front-end and back-end technologies.
            </AboutInfoP>
            <AboutInfoP>
  Passionate about algorithmic problem-solving and skilled in data structures, 
I am a determined and ambitious Full Stack Web Developer. Proficient in the MERN stack, 
I excel at creating user-centric solutions. With a quick learning ability and collaborative mindset, 
I thrive in interdisciplinary teams and deliver goal-oriented projects. Detail-oriented and analytical, 
I prioritize high-quality code and performance optimization. 
Strong teamwork and communication skills enable successful collaboration with stakeholders.
 Committed to staying updated with industry trends, 
I contribute to the success of innovative software development projects.
            </AboutInfoP>
          </AboutInfo>
          <HeaderUl>
            {socialMediaLinks.map((item) => (
              <JelloHori key={item.id}>
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  <HeaderLi>{item.icon}</HeaderLi>
                </a>
              </JelloHori>
            ))}
          </HeaderUl>
        </Column>
      </AboutDiv>
      <br />
    </Container>
  );
};

export default About;


